// store/sales/sales.actions.ts

import { createAction, props } from "@ngrx/store";
import { Item } from "app/modules/masters/item/model/item.model";
import { SalesHeader } from "app/modules/transactions/sales/models/sales-header.model";
import {
  SalesItem,
  SearchedSaleItem,
} from "app/modules/transactions/sales/models/sales-item.model";
import { SalesSummary } from "app/modules/transactions/sales/models/sales-summary.model";

// ===== Header Actions =====
export const updateSalesHeader = createAction(
  "[Sales] Update Header",
  props<{ header: Partial<SalesHeader> }>()
);

// ===== Item Actions =====
export const addSalesItem = createAction(
  "[Sales] Add Item",
  props<{ item: SalesItem }>()
);

export const updateSalesItem = createAction(
  "[Sales] Update Item",
  props<{ index: number; item: SalesItem }>()
);

export const removeSalesItem = createAction(
  "[Sales] Remove Item",
  props<{ index: number }>()
);

export const clearSalesItems = createAction("[Sales] Clear Items");

// ===== Summary Actions =====
export const updateSalesSummary = createAction(
  "[Sales] Update Summary",
  props<{ summary: SalesSummary }>()
);

// ===== Clear All (Form Reset) =====
export const resetSalesForm = createAction("[Sales] Reset Sales Form");

export const getFifoSplitBatches = createAction(
  "[Sales] Get FIFO Batches",
  props<{ itemId: string; quantity: number; rowIndex: number }>()
);

export const getFifoSplitBatchesSuccess = createAction(
  "[Sales] Get FIFO Batches Success",
  props<{ rowIndex: number; splitItems: SalesItem[] }>() // each batch converted to full SalesItem row
);

export const getFifoSplitBatchesFailure = createAction(
  "[Sales] Get FIFO Batches Failure",
  props<{ error: string }>()
);

export const createSales = createAction(
  "[Sales] Create Sales",
  props<{ sale: any }>()
);

export const createSalesSuccess = createAction(
  "[Sales] Create Sales Success",
  props<{ invoice: any }>() // Adjust model as needed
);

export const createSalesFailure = createAction(
  "[Sales] Create Sales Failure",
  props<{ error: string }>()
);

export const clearSalesForm = createAction("[Sales] Clear Sales Form");

export const searchSalesItems = createAction(
  "[Sales] Search Sales Items",
  props<{
    query: string;
    searchType: "name" | "code";
    storeId?: string;
    skip?: number;
    take?: number;
    rowIndex: number;
  }>()
);

export const searchSalesItemsSuccess = createAction(
  "[Sales] Search Sales Items Success",
  props<{
    items: SearchedSaleItem[];
    rowIndex: number;
  }>()
);

export const searchSalesItemsFailure = createAction(
  "[Sales] Search Sales Items Failure",
  props<{ error: any }>()
);

export const clearSaleSearchItems = createAction(
  "[Sale] Clear Sale Search Item"
)

